export const PHONE_DISPLAY = "(888) 506-3888";
export const PHONE_TEL = "tel:+18885063888";
export const COMPANY = "Specpay Solutions";

export const SERVICES = [
  {
    id: "start",
    title: "Start New Service",
    desc: "Move into a new home? Get electricity, gas or water turned on fast — usually same-day.",
    icon: "Zap",
    accent: "#FF4500",
  },
  {
    id: "stop",
    title: "Stop Service",
    desc: "Moving out or no longer need a connection? Schedule a clean disconnect in minutes.",
    icon: "PowerOff",
    accent: "#09090B",
  },
  {
    id: "move",
    title: "Transfer / Move Service",
    desc: "Relocating? Take your account with you to your new address — no re-enrollment needed.",
    icon: "MoveRight",
    accent: "#0055FF",
  },
  {
    id: "pay",
    title: "Pay Your Bill",
    desc: "Quick, secure bill pay over the phone. One call — your account is current.",
    icon: "CreditCard",
    accent: "#F97316",
  },
  {
    id: "manage",
    title: "Manage Account",
    desc: "Update payment methods, billing address, autopay or paperless. One number, all changes.",
    icon: "Settings",
    accent: "#EAB308",
  },
  {
    id: "outage",
    title: "Report an Outage",
    desc: "Lost power, gas or water? Report it instantly. Live agents 24/7.",
    icon: "AlertTriangle",
    accent: "#DC2626",
  },
];

export const UTILITIES = [
  {
    id: "electric",
    title: "Electricity",
    blurb: "Reliable residential & commercial power across all major service territories.",
    icon: "Zap",
    color: "#EAB308",
    image:
      "https://images.unsplash.com/photo-1413882353314-73389f63b6fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2l0eXxlbnwwfHx8fDE3NzgwOTM4MzV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "gas",
    title: "Natural Gas",
    blurb: "Safe natural gas hookups and transfers handled by certified specialists.",
    icon: "Flame",
    color: "#F97316",
    image:
      "https://images.unsplash.com/photo-1510772314292-9c0ad420734a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxmbGFtZXxlbnwwfHx8fDE3NzgwOTM4NDN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "water",
    title: "Water",
    blurb: "Clean residential water service activation, transfers and stop requests.",
    icon: "Droplets",
    color: "#0055FF",
    image:
      "https://images.unsplash.com/photo-1606214554354-06acd2c0480f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMHNwbGFzaGluZyUyMHdhdGVyfGVufDB8fHx8MTc3ODA5MzgyNHww&ixlib=rb-4.1.0&q=85",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1617788587804-10346bac2ac3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBidWlsZGluZyUyMGRheWxpZ2h0fGVufDB8fHx8MTc3ODA5MzgzNHww&ixlib=rb-4.1.0&q=85";

export const SUPPORT_IMAGE =
  "https://images.unsplash.com/photo-1525182008055-f88b95ff7980?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxwaG9uZSUyMHN1cHBvcnR8ZW58MHx8fHwxNzc4MDkzODQzfDA&ixlib=rb-4.1.0&q=85";

export const MARQUEE_ITEMS = [
  "24/7 Live Support",
  "Same-Day Service",
  "Licensed Specialists",
  "All 50 States",
  "No Hidden Fees",
  "Transparent Pricing",
  "Fast Phone Setup",
  "Trusted by Thousands",
];
